"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nameIDPolicyFormats = exports.nameIDOptions = exports.isActiveServer = exports.initSamlData = exports.initSAMLProviderStatus = exports.initProviderConfig = exports.getIdentityID = void 0;
var _uuid = require("uuid");
var _globalStates = require("../../globalstates/globalStates");
// not requried in the frontend

var nameIDPolicyFormats = exports.nameIDPolicyFormats = [{
  id: "Email Address",
  label: "Email Address",
  value: "urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress"
}, {
  id: "Unspecified",
  label: "Unspecified",
  value: "urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified"
}, {
  id: "X.509 Subject Name",
  label: "X.509 Subject Name",
  value: "urn:oasis:names:tc:SAML:1.1:nameid-format:x509SubjectName"
}, {
  id: "Persistent",
  label: "Persistent",
  value: "urn:oasis:names:tc:SAML:2.0:nameid-format:persistent"
}, {
  id: "Transient",
  label: "Transient",
  value: "urn:oasis:names:tc:SAML:2.0:nameid-format:transient"
}];
var nameIDOptions = exports.nameIDOptions = [{
  id: "Email Address",
  label: "Email Address",
  value: "emailAddress"
}, {
  id: "Unspecified",
  label: "Unspecified",
  value: "unspecified"
}, {
  id: "X.509 Subject Name",
  label: "X.509 Subject Name",
  value: "x509SubjectName"
}, {
  id: "Persistent",
  label: "Persistent",
  value: "persistent"
}, {
  id: "Transient",
  label: "Transient",
  value: "transient"
}];
var getIdentityID = exports.getIdentityID = function getIdentityID(accessURL) {
  return "".concat(accessURL, "/auth/realms/userful");
};
var initSAMLProviderStatus = exports.initSAMLProviderStatus = function initSAMLProviderStatus(accessURL) {
  return {
    provider: {
      id: {
        value: ""
      },
      config: [{
        id: {
          value: (0, _uuid.v4)()
        },
        displayName: "",
        syncMode: "FORCE",
        alias: "",
        type: null,
        entityId: getIdentityID(accessURL),
        idpEntityId: "",
        singleSignOnServiceUrl: "",
        singleLogoutServiceUrl: "",
        nameIdPolicyFormat: "EMAIL_ADDRESS"
      }, {
        id: {
          value: (0, _uuid.v4)()
        },
        displayName: "",
        syncMode: "FORCE",
        alias: "",
        type: null,
        entityId: "",
        idpEntityId: "",
        singleSignOnServiceUrl: "",
        singleLogoutServiceUrl: "",
        nameIdPolicyFormat: "EMAIL_ADDRESS"
      }],
      enabled: false
    },
    error: false,
    errorMassage: "",
    errorKey: "NONE"
  };
};
var initProviderConfig = exports.initProviderConfig = function initProviderConfig() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    displayName: "",
    syncMode: "FORCE",
    alias: "",
    type: null,
    entityId: "",
    idpEntityId: "",
    singleSignOnServiceUrl: "",
    singleLogoutServiceUrl: "",
    nameIdPolicyFormat: "EMAIL_ADDRESS"
  };
};
var initSamlData = exports.initSamlData = function initSamlData() {
  return {
    providers: []
  };
};
var isActiveServer = exports.isActiveServer = function isActiveServer(redirectURL) {
  if (redirectURL === "") {
    return false;
  }
  var activeAccessURL = (0, _globalStates.getGlobalStates)().host;
  return redirectURL.indexOf(activeAccessURL) !== -1;
};